import styles from './Faq.module.css';
import React, {useState} from "react";

function Faq(props) {

    const [selectedIndex, setSelectedIndex] = useState(0);

    const FAQ = (props) => (
        <div>
            {props.items.map( (item, index) => (
                <div className={styles.item} onClick={() => index == selectedIndex ? setSelectedIndex(-1) : setSelectedIndex(index)}>
                    <table>
                        <tbody>
                        <tr >
                            <td style={{width: '100%'}}>{item.question}</td>
                            <td style={{color: '#62a615'}}>{selectedIndex == index ? '-' : '+'}</td>
                        </tr>
                        </tbody>
                    </table>
                    {selectedIndex == index && (
                        <div className={styles.itemContent}>
                            {item.answer}
                        </div>
                    )}
                </div>
            ))}
        </div>
    )
  return (
      <FAQ items={props.items}/>
  );
}

export default Faq;
